'use strict'
/**
 * Conexión de la base de datos firebase, exportando el modulo para ser utilizado en los demas
 * componentes.
 */

const firebase = require('firebase')

const config = { 
    //develop
    
    apiKey: "AIzaSyAoE2E_kgDKmGqcaKFsdR9dbvo7S8PvWDk",
    authDomain: "gootwork-df81e.firebaseapp.com",
    projectId: "gootwork-df81e",
    storageBucket: "gootwork-df81e.appspot.com",
    messagingSenderId: "121427129437",
    appId: "1:121427129437:web:706da1e16f5b139fbbc9b4"
    

    //production
    /*
    apiKey: "AIzaSyCWFVqI_anTH5phWnjyG4KnthAoekbmo3w",
    authDomain: "hiproyect-fileserver.firebaseapp.com",
    databaseURL: "https://hiproyect-fileserver.firebaseio.com",
    projectId: "hiproyect-fileserver",
    storageBucket: "hiproyect-fileserver.appspot.com",
    messagingSenderId: "548703513228",
    appId: "1:548703513228:web:ec39c74287fb958e3629a9",
    measurementId: "G-BVZ294CKLH"
    */
}

const app = firebase.initializeApp(config)

const fbstorage = app.storage()

module.exports = fbstorage
